module.exports = __webpack_public_path__ + "img/quyu.65d913c5.png";